import "./App.css";
import Board from "./Board";

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
